import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazz.bet/bzfront/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazz.bet/bzfront/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/developer/www/bazz.bet/bzfront/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/developer/www/bazz.bet/bzfront/src/components/Footer/Footer.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazz.bet/bzfront/src/components/Footer/FooterListLink/FooterNavLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazz.bet/bzfront/src/components/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazz.bet/bzfront/src/components/init.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazz.bet/bzfront/src/components/Modal/Modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazz.bet/bzfront/src/components/ModalConfirm/ModalConfirm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazz.bet/bzfront/src/components/Navigation/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastNotifyContainer"] */ "/home/developer/www/bazz.bet/bzfront/src/components/UI/ToastContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SWRProvider"] */ "/home/developer/www/bazz.bet/bzfront/src/contexts/swr-provider.tsx");
